module.exports = __webpack_public_path__ + "img/emoji_105.6037e183.png";